







































































































































































































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import Api from "@/api";
import swal from "sweetalert";
import FormErrorsMixin from "@/mixins/FormErrors";
import { AxiosResponse } from "axios";

import "vue-swatches/dist/vue-swatches.css";

import ViewLoader from "@/components/Common/ViewLoader.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import WarningButton from "@/components/Common/Buttons/WarningButton.vue";
import NewCustomerModal from "@/components/Customers/Customer/NewCustomerModal.vue";
import SearchableSelect from "@/components/Common/Select/SearchableSelect.vue";
import Error404 from "@/components/Common/Error404.vue";

import "vue-slider-component/theme/default.css";
import {
  ICustomer,
  IDiscount,
  IEvent,
  IEventPrice,
  IPaymentType,
  IVat
} from "@/interface";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    InfoButton,
    WarningButton,
    NewCustomerModal,
    SearchableSelect,
    Error404
  }
})
export default class BookingEventDetails extends Mixins(FormErrorsMixin) {
  public loading = false;
  public updating = false;
  public validatedInputs = [
    "customer_id",
    "payment_type_id",
    "event_id",
    "starts_at",
    "ends_at",
    "use_manual_price",
    "events.0.customer_id",
    "events.0.payment_type_id",
    "events.0.event_id",
    "events.0.starts_at",
    "events.0.ends_at",
    "events.0.use_manual_price",
    "events.0.manual_price_amount_gross"
  ];
  private noDataExist = false;
  private bookingName: string | null = null;
  private showAddCustomerModal = false;
  private selectedBooking: any = {
    paymentMethod: null,
    remarks: null,
    customer: null as any,
    event_id: null,
    price: null as number | null,
    discount_id: "",
    amount_net: null,
    amount_gross: null,
    vat: null as IVat | null,
    manual_price_vat_id: null,
    manual_price_amount_gross: null,
    use_manual_price: false
  };
  private selectedBookingId: string | null = null;
  private paymentTypes: Array<IPaymentType> = [];
  private discounts: Array<IDiscount> = [];
  private customers: Array<ICustomer> = [];
  private events: Array<IEvent> = [];
  private vats: Array<IVat> = [];
  private prices: Array<IEventPrice> = [];
  private debounce: any = null;

  private beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: this) => {
      vm.selectedBookingId = vm.$route.params.booking_id;
      if (
        typeof vm.selectedBookingId !== "undefined" &&
        vm.selectedBookingId !== null
      ) {
        vm.getEventBooking();
        if (vm.$route.query.customer_created === "true") {
          swal("Success!", "The Customer was created.", "success").then(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          });
        }
        if (vm.$route.query.booking_created === "true") {
          swal("Success!", "The Booking was created.", "success").then(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          });
        }
      }
      vm.getEvents();
      vm.getVats();
      vm.getPaymentTypes();
      vm.getDiscounts();
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any) {
    if (
      typeof this.selectedBookingId !== "undefined" &&
      this.selectedBookingId !== null
    ) {
      this.getEventBooking();
    }
    this.getEvents();
    this.getVats();
    this.getPaymentTypes();
    this.getDiscounts();
    next();
  }

  @Watch("selectedBooking.event_id")
  selectedBooking_event_id_changed(newState: string): void {
    if (!newState) return;
    this.prices = [];
    this.getEventPrices(newState, (prices: Array<IEventPrice>) => {
      this.prices = prices.map((price: IEventPrice) => ({
        id: price.id,
        name: `${price.name} - ${price.amount_gross} EUR`
      }));
      const selectedPrice = this.prices.find(
        price => price.id === this.selectedBooking.price
      );
      if (!selectedPrice && this.prices.length > 0 && this.prices[0].id) {
        this.selectedBooking.price =
          this.prices.length > 0 ? this.prices[0].id : null;
      }
    });
  }

  private cancelBooking(): void {
    this.$router.push({ name: "BookingEvents" });
  }

  private createOrUpdateBooking(): void {
    if (this.selectedBookingId == null) {
      this.createBooking();
    } else {
      this.updateBooking();
    }
  }

  private generateSavingData(type: string): any {
    if (type === "create") {
      return {
        customer_id: this.selectedBooking.customer?.id,
        payment_type_id: this.selectedBooking.paymentMethod,
        internal_note: this.selectedBooking.remarks,
        events: [
          {
            event_id: this.selectedBooking.event_id,
            discount_id: this.selectedBooking.discount_id,
            price_id: this.selectedBooking.price,
            use_manual_price: this.selectedBooking.use_manual_price,
            manual_price_amount_gross: this.selectedBooking
              .manual_price_amount_gross,
            manual_price_vat_id: this.selectedBooking.manual_price_vat_id
          }
        ]
      };
    } else {
      return {
        customer_id: this.selectedBooking.customer?.id,
        payment_type_id: this.selectedBooking.paymentMethod,
        internal_note: this.selectedBooking.remarks,
        event_id: this.selectedBooking.event_id,
        discount_id: this.selectedBooking.discount_id,
        price_id: this.selectedBooking.price,
        use_manual_price: this.selectedBooking.use_manual_price,
        manual_price_amount_gross: this.selectedBooking
          .manual_price_amount_gross,
        manual_price_vat_id: this.selectedBooking.manual_price_vat_id
      };
    }
  }

  private getEventBooking(): void {
    this.loading = true;
    const endpoint = this.$partnerEndpoint(
      `bookings/events/${this.selectedBookingId}`
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        const eventBooking = response.data.data;
        const customer = eventBooking.booking.customer;

        this.selectedBooking.customer = {
          id: customer.id,
          name: `${customer.last_name} ${customer.first_name}`
        };
        this.bookingName = "Event Booking";
        this.selectedBooking.paymentMethod =
          eventBooking.booking.payment_type.id;
        this.selectedBooking.remarks = eventBooking.booking.internal_note;
        this.selectedBooking.amount_net =
          eventBooking.booking.total_price.amount_net;
        this.selectedBooking.amount_gross =
          eventBooking.booking.total_price.amount_gross;
        this.selectedBooking.vat = eventBooking.booking.total_price.vat_amount;
        this.selectedBooking.event_id = eventBooking.event.id;
        this.selectedBooking.discount_id = eventBooking.discount
          ? eventBooking.discount.id
          : "";

        const eventPrice = eventBooking.event_price;
        if (eventPrice.type === "manual") {
          this.selectedBooking.use_manual_price = true;
          this.selectedBooking.manual_price_vat_id = eventPrice.vat
            ? eventPrice.vat.id
            : null;
          this.selectedBooking.manual_price_amount_gross =
            eventPrice.amount_gross;
        } else {
          this.selectedBooking.price = eventPrice.id;
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private createBooking(): void {
    if (this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint = this.$partnerEndpoint("bookings/events");
    const bookingInfo = this.generateSavingData("create");

    Api()
      .post(endpoint, bookingInfo)
      .then((response: AxiosResponse) => {
        this.selectedBookingId = response.data.data.id;
        this.$router.push({
          name: "BookingEventDetails",
          params: {
            booking_id:
              this.selectedBookingId !== null ? this.selectedBookingId : "null"
          },
          query: { booking_created: "true" }
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private updateBooking(): void {
    if (this.loading || this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint = this.$partnerEndpoint(
      `bookings/events/${this.selectedBookingId}`
    );
    const bookingInfo = this.generateSavingData("update");

    Api()
      .put(endpoint, bookingInfo)
      .then(() => {
        this.getEventBooking();
        swal({
          title: "Success!",
          text: "The booking was updated.",
          icon: "success"
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private onSearchChange(query: string): void {
    if (query.length >= 2) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getCustomers(query);
      }, 600);
    } else {
      this.customers = [];
    }
  }

  private getCustomers(query = ""): Promise<any> {
    const endpoint = this.$partnerEndpoint("customers");

    return Api()
      .get(endpoint, {
        params: {
          search: query
        }
      })
      .then((response: AxiosResponse) => {
        this.customers = response.data.data.map(
          ({ id, first_name, last_name }: any) => ({
            id,
            name: `${last_name} ${first_name}`
          })
        );
      })
      .catch((error: any) => {
        console.log(error.response);
      });
  }

  private getEvents(): void {
    const endpoint = this.$partnerEndpoint("events");

    Api()
      .get(endpoint, {
        params: {
          timeframe: "current"
        }
      })
      .then((response: AxiosResponse) => {
        this.events = response.data.data;
        const selectedEvent = this.$route.query.event_id
          ? this.events.find(
              event =>
                event.id === parseInt(`${this.$route.query.event_id}`, 10)
            )
          : null;
        if (this.$route.query.event_id) {
          if (selectedEvent) {
            this.selectedBooking.event_id = selectedEvent.id;
          }
        } else {
          if (!this.selectedBookingId && this.events.length > 0) {
            this.selectedBooking.event_id = this.events[0].id;
          }
        }
      })
      .catch((error: any) => {
        console.log(error.response);
      });
  }

  private getPaymentTypes(): void {
    const endpoint: string = this.$partnerEndpoint("payment-types");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.paymentTypes = response.data.data;
        if (!this.selectedBookingId && this.paymentTypes.length > 0) {
          this.selectedBooking.paymentMethod = this.paymentTypes[0].id;
        }
      })
      .catch((error: any) => {
        console.log(error.response);
      });
  }

  private getDiscounts(): void {
    const endpoint: string = this.$partnerEndpoint("discounts");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.discounts = response.data.data;
      })
      .catch((error: any) => {
        console.log(error.response);
      });
  }

  private getVats(): void {
    const endpoint: string = this.$partnerEndpoint("vats");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.vats = response.data.data;
        if (!this.selectedBookingId && this.vats.length > 0) {
          this.selectedBooking.manual_price_vat_id = this.vats[0].id;
        }
      })
      .catch((error: any) => {
        console.log(error.response);
      });
  }

  private getEventPrices(eventId: string, successCallback: any): void {
    const endpoint = this.$partnerEndpoint("events/" + eventId + "/prices");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        if (typeof successCallback == "function") {
          successCallback(response.data.data);
        }
      });
  }

  private openAddCustomerModal(): void {
    this.showAddCustomerModal = true;
  }

  private closeAddCustomerModal(): void {
    this.showAddCustomerModal = false;
  }

  private onSelectCustomer(customer: ICustomer): void {
    this.showAddCustomerModal = false;
    this.selectedBooking.customer = {
      id: customer.id,
      name: `${customer.last_name} ${customer.first_name}`
    };
    this.customers = [this.selectedBooking.customer];
  }
}
